<template>
    <div>
		<img src="../assets/img/detail/ck/1.jpg" width="100%" />
		<img src="../assets/img/detail/ck/2.jpg" width="100%"/>
		<img src="../assets/img/detail/ck/3.jpg" width="100%"/>
		<img src="../assets/img/detail/ck/4.jpg" width="100%"/>
		<img src="../assets/img/detail/ck/5.jpg" width="100%"/>
		<img src="../assets/img/detail/ck/6.jpg" width="100%"/>
		<img src="../assets/img/detail/ck/7.jpg" width="100%"/>
		<img src="../assets/img/detail/ck/8.jpg" width="100%"/>
		<img src="../assets/img/detail/ck/9.jpg" width="100%"/>
    </div>
</template>

<script>
    export default {
        name: 'Product_sswm',
        data: function () {
            return {
            }
        },
        mounted: function () {

        },
        created: function () {

        },
        methods: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>